// 로그인 토큰 (2026-10-14) — 서버가 로그인 때 주는 30일짜리 서명 토큰을 보관하고,
// 우리 API 의 /user/* · /alerts/* 요청에 자동으로 Authorization 헤더를 붙임 (fetch 를 한 번 감쌈 → 각 화면 코드는 그대로)
// 토큰이 만료·무효(PIN 변경 등)라 서버가 401 을 주면 'dgds-auth-expired' 이벤트 → App 이 로그아웃 처리
const API = process.env.REACT_APP_API_URL || "http://localhost:3001";
const KEY = "dgds-auth";

export function getAuth() {
  try { const a = JSON.parse(localStorage.getItem(KEY) || "null"); return a && a.token && a.exp > Date.now() ? a : null; } catch { return null; }
}
export function setAuth(token, exp) {
  try { if (token && exp) localStorage.setItem(KEY, JSON.stringify({ token, exp })); } catch {}
}
export function clearAuth() {
  try { localStorage.removeItem(KEY); } catch {}
}

// 만료 7일 전부터는 앱을 열 때 조용히 새 토큰으로 바꿈 → 매일 쓰면 계속 로그인 유지
export async function refreshAuthIfNeeded(force = false) {
  const a = getAuth();
  if (!a) return null;
  if (!force && a.exp - Date.now() > 7 * 86400 * 1000) return a;
  try {
    const res = await fetch(`${API}/auth/refresh`, { method: "POST", headers: { Authorization: `Bearer ${a.token}` } });
    if (!res.ok) return res.status === 401 ? null : a;
    const j = await res.json();
    if (j.token && j.tokenExp) { setAuth(j.token, j.tokenExp); return { token: j.token, exp: j.tokenExp }; }
  } catch {}
  return a;
}

const needsAuth = (url) => {
  if (!url || !url.startsWith(API)) return false;
  try { return /^\/(user|alerts)\//.test(new URL(url).pathname); } catch { return false; }
};

if (typeof window !== "undefined" && !window.__DGDS_AUTH_FETCH__) {
  window.__DGDS_AUTH_FETCH__ = true;
  const orig = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : input && input.url;
    if (!needsAuth(url)) return orig(input, init);
    const a = getAuth();
    if (a) {
      const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined));
      headers.set("Authorization", `Bearer ${a.token}`);
      init = { ...init, headers };
    }
    const res = await orig(input, init);
    if (res.status === 401 && a) { clearAuth(); window.dispatchEvent(new Event("dgds-auth-expired")); }
    return res;
  };
}
